<app-input-wrapper
  [label]="label"
  [label2]="label2"
  [labelOnPress]="labelOnPress"
  [valueLabel]="valueLabel"
  [required]="required"
  [errorMessage]="errorMessage"
  [touched]="touched"
  [alt]="alt"
  [onPress]="onPress"
  [disabled]="disabled ?? false"
  [readonly]="readonly ?? false"
  [leftIcon]="leftIcon"
  [rightIcon]="rightIcon"
>
  <p-multiSelect
    [styleClass]="'full-width-dropdown'"
    [options]="options"
    [group]="group"
    [maxSelectedLabels]="maxSelectedLabels"
    [(ngModel)]="value"
    [placeholder]="placeholder"
    [disabled]="disabled ?? false"
    [readonly]="readonly ?? false"
    [optionLabel]="optionLabel"
    [optionValue]="optionValue"
    (onChange)="handleSelectChange($event)"
    [filter]="filter"
    [appendTo]="'body'"
    [showHeader]="filter"
  >
    @if (group) {
      <ng-template let-group #group>
        <span>{{ group.label }}</span>
      </ng-template>
    }
  </p-multiSelect>
</app-input-wrapper>
